// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorCodesFormController from "./color_codes_form_controller"
application.register("color-codes-form", ColorCodesFormController)

import ColorHighlighterController from "./color_highlighter_controller"
application.register("color-highlighter", ColorHighlighterController)

import ControlListFormController from "./control_list_form_controller"
application.register("control-list-form", ControlListFormController)

import ControlListStorageController from "./control_list_storage_controller"
application.register("control-list-storage", ControlListStorageController)

import ExtraJarController from "./extra_jar_controller"
application.register("extra-jar", ExtraJarController)

import DebouncedSubmitController from "./debounced_submit_controller"
application.register("debounced-submit", DebouncedSubmitController)

import FilePreviewsController from "./file_previews_controller"
application.register("file-previews", FilePreviewsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PasswordGeneratorController from "./password_generator_controller"
application.register("password-generator", PasswordGeneratorController)

import ProductionCanvasFormController from "./production_canvas_form_controller"
application.register("production-canvas-form", ProductionCanvasFormController)

import StickerFormController from "./sticker_form_controller"
application.register("sticker-form", StickerFormController)

import ProductionPaletteFormController from "./production_palette_form_controller"
application.register("production-palette-form", ProductionPaletteFormController)

import ProcessingFilesController from "./processing_files_controller"
application.register("processing-files", ProcessingFilesController)

import ProcessingResultStatusController from "./processing_result_status_controller"
application.register("processing-result-status", ProcessingResultStatusController)

import ProcessingStatusController from "./processing_status_controller"
application.register("processing-status", ProcessingStatusController)

import ProcessingsListController from "./processings_list_controller"
application.register("processings-list", ProcessingsListController)

import PalleteConvertationStatusController from "./pallete_convertation_status_controller"
application.register("pallete-convertation-status", PalleteConvertationStatusController)

import QrCodeController from "./qr_code_controller"
application.register("qr-code", QrCodeController)

import TabsUrlController from "./tabs_url_controller"
application.register("tabs-url", TabsUrlController)

import AmPaletteStatusController from "./am_palette_status_controller"
application.register("am-palette-status", AmPaletteStatusController)

import AmSizePresetFieldsController from "./am_size_preset_fields_controller"
application.register("am-size-preset-fields", AmSizePresetFieldsController)

import AmProcessingStatusController from "./am_processing_status_controller"
application.register("am-processing-status", AmProcessingStatusController)

import AmProcessingResultStatusController from "./am_processing_result_status_controller"
application.register("am-processing-result-status", AmProcessingResultStatusController)

import AmPaletteEditController from "./am_palette_edit_controller"
application.register("am-palette-edit", AmPaletteEditController)

import CanvasTemplateFieldsController from "./canvas_template_fields_controller"
application.register("canvas-template-fields", CanvasTemplateFieldsController)

import AmResultFormController from "./am_result_form_controller"
application.register("am-result-form", AmResultFormController)

import MesSettingsController from "./mes_settings_controller"
application.register("mes-settings", MesSettingsController)

import ProxySettingsController from "./proxy_settings_controller"
application.register("proxy-settings", ProxySettingsController)

import ProductionReadinessController from "./production_readiness_controller"
application.register("production-readiness", ProductionReadinessController)

import MesDispatchController from "./mes_dispatch_controller"
application.register("mes-dispatch", MesDispatchController)

import PollRefreshController from "./poll_refresh_controller"
application.register("poll-refresh", PollRefreshController)
